export default __webpack_public_path__ + "static/media/contextual-chocolate@3x.dc792d7d.png";